var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input--text input--text-numbers",
      class: { "right-padding": _vm.removeIcon }
    },
    [
      _c("div", { staticClass: "input-top mg mg--b-2" }, [
        _c("p", { staticClass: "title-input text-small blueDark" }, [
          _vm._v(_vm._s(_vm.$t("areaMeasurement.damageArea")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "input__wrapper input__area" },
        [
          _c("input", {
            attrs: {
              name: "height",
              type: "number",
              placeholder: _vm.$t("areaMeasurement.heightMeasurement")
            },
            domProps: { value: _vm.height },
            on: {
              input: function($event) {
                return _vm.handleMeasure($event)
              },
              change: function($event) {
                return _vm.emitMeasure($event)
              }
            }
          }),
          _c("input", {
            attrs: {
              name: "width",
              type: "number",
              placeholder: _vm.$t("areaMeasurement.widhtMeasurement")
            },
            domProps: { value: _vm.width },
            on: {
              input: function($event) {
                return _vm.handleMeasure($event)
              },
              change: function($event) {
                return _vm.emitMeasure($event)
              }
            }
          }),
          _c(
            "span",
            { staticClass: "input__icon" },
            [
              _c("svgicon", {
                attrs: { icon: "ico-surface", height: "18", color: "#FFFFFF" }
              })
            ],
            1
          ),
          _c("ma-input-select", {
            staticClass: "input__area--select",
            attrs: {
              type: "select",
              name: "unitselect",
              icon: "ico-surface",
              options: _vm.units,
              col: "2",
              literal: "",
              value: _vm.selected
            },
            on: {
              change: function($event) {
                return _vm.emitMeasure($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }